/**
 * AI Chat Page
 *
 * Full-page AI Chat interface for the simplified UI mode.
 */

import React, { useEffect } from 'react';
import { Box } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { useTranslation } from 'react-i18next';
import { ChatLayout } from '../features/ai-chat';
import useAIChatStore from '../stores/ai-chat-store';

const AIChatPage: React.FC = () => {
  const { classes } = useStyles();
  const { i18n } = useTranslation();

  const setContext = useAIChatStore((state) => state.setContext);

  // Set context on mount and when language changes
  useEffect(() => {
    setContext({ currentPage: 'ai-chat', locale: i18n.language });
  }, [setContext, i18n.language]);

  return (
    <Box className={classes.pageContainer}>
      {/* Main chat area - full width for better experience */}
      <Box className={classes.chatArea}>
        <ChatLayout embedded className={classes.embeddedChat} />
      </Box>
    </Box>
  );
};

const useStyles = makeStyles()((theme) => ({
  pageContainer: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%', // Fill parent container (appFrame already accounts for header)
    position: 'relative',
    backgroundColor: theme.palette.backgrounds.main_new,
  },
  chatArea: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: 'transparent',
    overflow: 'hidden',
  },
  embeddedChat: {
    height: '100%',
    backgroundColor: 'transparent',
  },
}));

export default AIChatPage;

